import React, { Component } from 'react';
import { Load } from './basic';
import Autosuggest from 'react-autosuggest';
import axios from 'axios';
import '../../public/less/userSearch.less';

// codepen: http://codepen.io/moroshko/pen/EPZpev

function getSuggestionValue(suggestion) {
    return suggestion.text;
}

function renderSuggestion(suggestion) {
    return (
        <span>{suggestion.text}</span>
    );
}

module.exports = class userSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.Value.text,
            suggestions: [],
            isLoading: false
        };
        this.selectedSuggestion = {};
    }

    getUser() {
        var user = {
            ID: 0,
            text: ''
        };
        if (this.selectedSuggestion.ID != undefined && this.selectedSuggestion.ID != 0)
            user.ID = this.selectedSuggestion.ID;
        else
            user.text = this.state.value;

        return user;
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.value != nextProps.Value.text) {
            this.setState({ value: nextProps.Value.text });
            this.selectedSuggestion = {};
        }
    }

    onSuggestionsFetchRequested(value) {
        this.loadSuggestions(value.value);
    };

    onSuggestionsClearRequested() {
        var user = {
            ID: 0,
            text: ''
        };
        this.selectedSuggestion = user;
        this.setState({ suggestions: [] });
    };

    onSuggestionSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
        this.selectedSuggestion = suggestion;
    };

    loadSuggestions(value) {
        if (value.length >= 2) {
            this.setState({ isLoading: true });

            var suggestions = this.state.suggestions;
            axios
                .get('/data/getUser', {
                    params: {
                        searchText: value
                    }
                })
                .then(function (response) {
                    this.setState({ suggestions: response.data });
                }.bind(this))
                .catch(function (error) {
                    if (error.response && error.response.data == "No permissions") {
                        window.location.replace("/login");
                    }
                    console.log(error);
                });
        }
    }

    onChange(e, newValue) {
        this.setState({ value: newValue.newValue });
        //this.props.onChange(newValue); 
    };

    render() {
        const { value, suggestions, isLoading } = this.state;
        const inputProps = {
            placeholder: "Search a name...",
            value,
            onChange: this
                .onChange
                .bind(this)
        };
        return (
            <div className='userSearch'>
                <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={this
                        .onSuggestionsFetchRequested
                        .bind(this)}
                    onSuggestionSelected={this
                        .onSuggestionSelected
                        .bind(this)}
                    onSuggestionsClearRequested={this
                        .onSuggestionsClearRequested
                        .bind(this)}
                    getSuggestionValue={getSuggestionValue.bind(this)}
                    renderSuggestion={renderSuggestion.bind(this)}
                    inputProps={inputProps} />
            </div>
        )

    }
}



// WEBPACK FOOTER //
// ./modules/common/userSearch.jsx